// import React, {useEffect, useState} from 'react'
// import { useParams } from "react-router-dom";
// import distributorServices from '../../Services/distributorServices'
// import axios from "axios";

// const SupplierLedger = () => {
//     const { id } = useParams();
//     const [supplier, setSupplier] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [ledger, setLedger] = useState([]);

//     useEffect(() => {
//         const fetchSupplier = async () => {
//           try {
//             const response = await distributorServices.fetchSingle(id);
//             setSupplier(response.distributor);
//           } catch (error) {
//             console.error("Error fetching supplier details:", error);
//           } finally {
//             setLoading(false);
//           }
//         };
//         fetchSupplier();
//     }, [id]);

//     useEffect(() => {
//         const fetchLedger = async () => {
//             try {
//                 // Replace with your actual API endpoint for supplier ledger
//                 const response = await axios.get(`/pharmacyLedger/supplier-ledger/${id}`);
//                 setLedger(response.data.ledger || []);
//             } catch (error) {
//                 setLedger([]);
//             }
//         };
//         if (id) fetchLedger();
//     }, [id]);

//     return (
//     <div>
//       <div className='flex justify-center items-center'>
//         <div className="bg-white shadow-lg p-8 w-[90%] mt-2 border-gray-300 border-2 rounded-3xl">
//             <div className="flex flex-col">
//                 <div className="text-primary text-2xl font-bold">
//                  {supplier?.company}
//                 </div>
//                 <div className="text-base text-gray-500 font-semibold mt-2">{supplier?.name} </div>
//                 <div className="text-base font-semibold text-gray-500">{supplier?.phone}</div>
//                 <div className="text-base text-gray-500">
//                     {" "}
//                     {supplier?.address}
//                 </div>
//             </div>
//         </div>
//       </div>
//       <div className='flex flex-col justify-center items-center mt-10'>
//             <div className="flex flex-row gap-12 justify-end w-[90%]">
//                 <div className="flex gap-3 items-center">
//                     <label className="text-md text-gray-700 font-bold">
//                         Start Date :{" "}
//                     </label>
//                     <input
//                         type="date"
//                         name="start_date"
//                         className="border-b-2 border-gray-400 focus:outline-none focus:border-primary"
//                     />
//                 </div>
//                 <div className="flex gap-3 items-center">
//                     <label className="text-md text-gray-700 font-bold">
//                         End Date :
//                     </label>
//                     <input
//                         type="date"
//                         name="end_date"
//                         className="border-b-2 border-gray-400 focus:outline-none focus:border-primary"
//                     />
//                 </div>
//             </div>
//             <table className=" animate_animated animate_fadeIn border-separate border-spacing-y-4 w-[90%]">
//                 <thead className="bg-primary shadow-lg border-separate-2 border-spacing-y-2">
//                 <tr className="uppercase text-sm leading-normal w-full text-white bg-gray-700">
//                     <th className="rounded-l-lg  p-[1.5%] text-left text-[13px] w-[2%]">
//                         Date
//                     </th>
//                     <th className="  p-[1.5%] text-left text-[13px] w-[2%]">
//                         Reference
//                     </th>
//                     <th className="  p-[1.5%] text-left text-[13px] w-[2%]">
//                         Note
//                     </th>
//                     <th className="p-[1.5%] text-left text-[13px] w-[1%]">Credit</th>
//                     <th className="p-[1.5%] text-left text-[13px] w-[1%]">Debit</th>
//                     <th className="rounded-r-lg p-[1.5%] text-left text-[13px] w-[1%]">
//                         Balance
//                     </th>
//                 </tr>
//                 </thead>
//                 <tbody>
//                     {ledger.length === 0 ? (
//                         <tr>
//                             <td colSpan={6} className="text-center py-4">No ledger data found.</td>
//                         </tr>
//                     ) : (
//                         ledger.map((row, idx) => (
//                             <tr key={idx} className="rounded-lg border border-gray-400 shadow-sm shadow-gray-300">
//                                 <td className="py-[1%] px-[2%] text-left rounded-l-lg text-[15px] text-primary font-bold w-[1%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.date ? row.date.substring(0, 10) : ""}
//                                 </td>
//                                 <td className="py-[1%] px-[2%] text-left text-[15px] text-gray-700 font-light w-[2%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.reference}
//                                 </td>
//                                 <td className="py-[1%] px-[2%] text-left text-[15px] text-gray-700 font-light w-[2%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.note}
//                                 </td>
//                                 <td className="py-[1%] px-[2%] text-left text-[15px] font-medium w-[1%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.credit !== 0 ? row.credit : ""}
//                                 </td>
//                                 <td className="py-[1%] px-[2%] text-left text-[15px] font-medium w-[1%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.debit !== 0 ? row.debit : ""}
//                                 </td>
//                                 <td className="py-[1%] px-[2%] rounded-r-lg text-left text-[15px] font-light w-[1%] bg-gray-50 border-b border-primary border-opacity-25">
//                                     {row.balance}
//                                 </td>
//                             </tr>
//                         ))
//                     )}
//                 </tbody>
//             </table>
//         </div>
//     </div>
//   )
// }

// export default SupplierLedger;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import distributorServices from "../../Services/distributorServices";
import axios from "axios";

const SupplierLedger = () => {
  const { id } = useParams();
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ledger, setLedger] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const response = await distributorServices.fetchSingle(id);
        setSupplier(response.distributor);
      } catch (error) {
        console.error("Error fetching supplier:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSupplier();
  }, [id]);

  useEffect(() => {
    const fetchLedger = async () => {
      try {
        const response = await axios.get(
          `/pharmacyLedger/supplier-ledger/${id}`,
        );
        setLedger(response.data.ledger || []);
      } catch (error) {
        setLedger([]);
      }
    };
    if (id) fetchLedger();
  }, [id]);

  const colWidths = ["120px", "140px", "200px", "110px", "110px", "110px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      {/* ── Supplier Info Card ── */}
      {supplier && (
        <div className="border border-gray-200 rounded-xl bg-white px-4 py-4 mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-[14px] font-semibold text-gray-600 uppercase flex-shrink-0">
              {supplier?.company?.charAt(0) || "S"}
            </div>
            <div>
              <p className="text-[13px] font-semibold text-gray-800">
                {supplier?.company}
              </p>
              <p className="text-[11px] text-gray-500">
                {supplier?.name} · {supplier?.phone}
              </p>
              <p className="text-[11px] text-gray-400">{supplier?.address}</p>
            </div>
          </div>
        </div>
      )}

      {/* ── Header + Date Filters ── */}
      <div className="flex flex-wrap items-center justify-between gap-3 mb-16">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Supplier Ledger
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {ledger.length} entries
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">From</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
          <div className="flex items-center gap-1.5">
            <label className="text-xs text-gray-500">To</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-700 bg-white focus:outline-none focus:ring-1 focus:ring-blue-100"
            />
          </div>
        </div>
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : ledger.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No ledger data found
          </div>
        ) : (
          ledger.map((row, idx) => (
            <div
              key={idx}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center justify-between mb-2">
                <p className="text-[12px] font-semibold text-gray-700">
                  {row.date ? row.date.substring(0, 10) : "—"}
                </p>
                <span className="text-[11px] text-gray-500">
                  {row.reference}
                </span>
              </div>
              <div className="divide-y divide-gray-100">
                {[
                  { label: "Note", value: row.note },
                  {
                    label: "Credit",
                    value: row.credit !== 0 ? row.credit : "—",
                  },
                  { label: "Debit", value: row.debit !== 0 ? row.debit : "—" },
                  { label: "Balance", value: row.balance },
                ].map(({ label, value }) => (
                  <div key={label} className="flex justify-between py-1.5">
                    <span className="text-[11px] text-gray-400 w-16">
                      {label}
                    </span>
                    <span className="text-[11px] text-gray-700 text-right">
                      {value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Date",
                  "Reference",
                  "Note",
                  "Credit",
                  "Debit",
                  "Balance",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${i < 5 ? "border-r border-white/10" : ""}`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : ledger.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No ledger data found
                  </td>
                </tr>
              ) : (
                ledger.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${idx % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-medium text-gray-700 border-r border-gray-100">
                      {row.date ? row.date.substring(0, 10) : "—"}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {row.reference}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100 truncate">
                      {row.note}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {row.credit !== 0 ? row.credit : ""}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100">
                      {row.debit !== 0 ? row.debit : ""}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] font-medium text-gray-800">
                      {row.balance}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={6}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {ledger.length} total entries
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SupplierLedger;
